import { createSelector } from '@ngrx/store';

import { getBackState, IBackState } from '../back.state';
import { BackEntitiesSelectionFeatureKey, entitiesSelectionAdapter, EntitiesSelectionValue, IBackEntitiesSelectionState } from './entities-selection.state';

const getBackEntitiesSelectionState = createSelector(
    getBackState,
    (state: IBackState) => state[BackEntitiesSelectionFeatureKey]
);

const { selectEntities } = entitiesSelectionAdapter.getSelectors();

const getAllSelections = createSelector(
    getBackEntitiesSelectionState,
    (state: IBackEntitiesSelectionState) => selectEntities(state.selections)
);
export const getBackEntitiesSelection = (key: string) => createSelector(
    getAllSelections,
    (selections) => selections[key] ?? new EntitiesSelectionValue(key)
);
